import React, { useEffect, memo, createElement } from 'react';
import { ToorakRoadMap } from './components/ToorakRoadMap';
export function App() {
  useEffect(() => {
    // Google Analytics GA4
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-N48MJ5BXHP';
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-N48MJ5BXHP');
    `;
    document.head.appendChild(inlineScript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(inlineScript);
    };
  }, []);
  return <div className="min-h-screen bg-white selection:bg-black selection:text-white pb-safe" data-id="element-0">
      {/* Navigation - Transparent & Seamless */}
      <nav className="absolute top-0 w-full z-50 px-6 md:px-12 py-6 flex justify-between items-center" data-id="element-1">
        <span className="font-body text-[11px] text-black tracking-widest uppercase font-medium" data-id="element-2">
          Agency Logo
        </span>
        <button className="border border-black text-black bg-transparent px-5 py-3 min-h-[44px] font-body text-[10px] tracking-widest uppercase hover:bg-black hover:text-white transition-all duration-500 flex items-center justify-center" data-id="element-3">
          Enquire Now
        </button>
      </nav>

      {/* Hero Section */}
      <section className="relative h-screen w-full overflow-hidden bg-white" data-id="element-4">
        {/* Top Left Label */}
        <div className="absolute top-28 left-6 md:left-12 z-20 flex items-center gap-4" data-id="element-5">
          <div className="w-8 h-[1px] bg-black" data-id="element-6"></div>
          <p className="font-body text-[10px] text-black tracking-widest uppercase" data-id="element-7">
            Exclusive Off-Market Offering
          </p>
        </div>

        {/* Video Background */}
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover opacity-90" data-id="element-8">
          <source src="https://cdn.magicpatterns.com/uploads/8BaiNeZsUH4k6kuiiPfgMA/VL_Example_Visual.mp4" type="video/mp4" data-id="element-9" />
        </video>

        {/* Seamless Light Gradient Overlay for text legibility at the bottom */}
        <div className="absolute inset-0 seamless-fade z-10" data-id="element-10"></div>

        {/* Bottom Content - Smaller Text */}
        <div className="absolute bottom-10 md:bottom-12 left-6 md:left-12 right-6 md:right-12 z-20 flex flex-col items-start" data-id="element-11">
          <p className="font-body text-black tracking-widest uppercase text-[10px] md:text-xs mb-3 md:mb-4" data-id="element-12">
            Toorak, Victoria
          </p>
          <h1 className="font-display font-normal text-5xl md:text-6xl lg:text-7xl text-black leading-[1.05] mb-6 md:mb-8" data-id="element-13">
            78 Hopetoun <br data-id="element-14" />
            <span className="italic text-gray-muted" data-id="element-15">Avenue.</span>
          </h1>

          <div className="w-full flex flex-col md:flex-row justify-between items-start md:items-end gap-6 md:gap-8 border-t border-black/10 pt-6 md:pt-8" data-id="element-16">
            <p className="font-body font-light text-gray-dark text-sm md:text-base max-w-md leading-relaxed" data-id="element-17">
              A masterclass in architectural elegance. Offered privately to a
              select portfolio of qualified buyers.
            </p>

            {/* Scroll Indicator */}
            <div className="hidden md:flex flex-col items-center gap-3" data-id="element-18">
              <span className="font-body text-[10px] text-black tracking-widest uppercase" data-id="element-19">
                Discover
              </span>
              <div className="w-[1px] h-12 bg-black/10 relative overflow-hidden" data-id="element-20">
                <div className="absolute top-0 left-0 w-full h-full bg-black animate-[scroll_2s_ease-in-out_infinite]" data-id="element-21"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Details Strip */}
      <section className="bg-white border-b border-black/5 relative z-20" data-id="element-22">
        <div className="grid grid-cols-2 md:grid-cols-4" data-id="element-23">
          {[{
          value: '5',
          label: 'Bedrooms'
        }, {
          value: '4',
          label: 'Bathrooms'
        }, {
          value: '1,240',
          label: 'SQM Land'
        }, {
          value: 'Private',
          label: 'Sale Status'
        }].map((stat, i) => <div key={i} className={`py-10 md:py-12 px-4 md:px-6 flex flex-col items-center justify-center text-center ${i !== 3 ? 'md:border-r border-black/5' : ''} ${i % 2 === 0 ? 'border-r border-black/5' : ''} ${i < 2 ? 'border-b border-black/5 md:border-b-0' : ''}`} data-id="element-24">
              <span className="font-display text-3xl md:text-4xl text-black mb-2 md:mb-3" data-id="element-25">
                {stat.value}
              </span>
              <span className="font-body text-[10px] text-gray-muted tracking-widest uppercase" data-id="element-26">
                {stat.label}
              </span>
            </div>)}
        </div>
      </section>

      {/* Property Description */}
      <section className="bg-offWhite py-16 md:py-32 px-6 md:px-12" data-id="element-27">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-24" data-id="element-28">
          <div className="md:col-span-5" data-id="element-29">
            <div className="flex items-center gap-4 mb-6 md:mb-8" data-id="element-30">
              <div className="w-8 h-[1px] bg-black" data-id="element-31"></div>
              <span className="font-body text-[10px] text-black tracking-widest uppercase" data-id="element-32">
                The Vision
              </span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-black leading-[1.1]" data-id="element-33">
              The <br data-id="element-34" />
              <span className="italic text-gray-muted" data-id="element-35">Residence.</span>
            </h2>
          </div>
          <div className="md:col-span-7 flex items-center" data-id="element-36">
            <p className="font-body font-light text-gray-dark text-base md:text-lg leading-[1.8] md:leading-[2] md:pl-12 md:border-l border-black/10" data-id="element-37">
              Set on one of Toorak's most coveted tree-lined streets, this
              exceptional family home is a rare offering of space, light, and
              craftsmanship. Positioned on a north-facing 1,240sqm allotment,
              the residence unfolds across two generous levels — with a seamless
              connection between indoors and out, resort-style entertaining, and
              interiors finished to an exacting standard.
            </p>
          </div>
        </div>
      </section>

      {/* Key Highlights */}
      <section className="bg-white py-16 md:py-32 px-6 md:px-12 border-y border-black/5" data-id="element-38">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-24" data-id="element-39">
          <div className="md:col-span-5" data-id="element-40">
            <h2 className="font-display text-4xl md:text-5xl text-black leading-[1.1] md:sticky md:top-32" data-id="element-41">
              Curated <br data-id="element-42" />
              <span className="italic text-gray-muted" data-id="element-43">Features.</span>
            </h2>
          </div>
          <div className="md:col-span-7" data-id="element-44">
            <ul className="flex flex-col border-t border-black/5" data-id="element-45">
              {['Five bedrooms including master retreat with walk-in robe and ensuite', 'Four bathrooms, study, and powder room', 'Heated pool and spa with north-facing garden and entertaining terrace', 'Gourmet kitchen with stone benchtops and full Miele appliance suite', 'Separate dining, formal sitting, and casual living zones', 'Triple garage with internal access and storage', '1,240sqm north-facing allotment — a rarity at this address', 'Walking distance to Toorak Village, Fawkner Park, and elite private schools'].map((item, i) => <li key={i} className="py-5 md:py-6 border-b border-black/5 last:border-0 flex flex-row items-start md:items-center gap-4 md:gap-8 group" data-id="element-46">
                  <span className="font-display italic text-xl md:text-2xl text-gray-muted/50 group-hover:text-black transition-colors duration-500 mt-0.5 md:mt-0" data-id="element-47">
                    0{i + 1}
                  </span>
                  <span className="font-body font-light text-gray-dark text-sm md:text-base leading-relaxed group-hover:text-black transition-colors duration-500" data-id="element-48">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="bg-offWhite py-16 md:py-32 px-6 md:px-12" data-id="element-49">
        <div className="max-w-7xl mx-auto" data-id="element-50">
          <div className="flex items-center justify-center gap-4 mb-10 md:mb-16" data-id="element-51">
            <div className="w-8 h-[1px] bg-black" data-id="element-52"></div>
            <span className="font-body text-[10px] text-black tracking-widest uppercase" data-id="element-53">
              Visuals
            </span>
            <div className="w-8 h-[1px] bg-black" data-id="element-54"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-55">
            {[1, 2, 3].map(num => <div key={num} className="group relative overflow-hidden cursor-pointer" data-id="element-56">
                <div className="aspect-[4/5] w-full bg-gray-light border border-black/5 transition-transform duration-700 group-hover:scale-105" data-id="element-57"></div>
                <div className="absolute inset-0 bg-white/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center" data-id="element-58">
                  <span className="font-body text-[10px] text-black tracking-widest uppercase border border-black px-5 py-3 min-h-[44px] flex items-center justify-center" data-id="element-59">
                    View Image
                  </span>
                </div>
              </div>)}
          </div>
          <p className="font-body text-[10px] text-gray-muted tracking-widest uppercase text-center max-w-2xl mx-auto leading-loose" data-id="element-60">
            Full photography, floor plan and property memorandum available upon
            approved enquiry.
          </p>
        </div>
      </section>

      {/* Location */}
      <ToorakRoadMap data-id="element-61" />

      {/* Agent Section */}
      <section className="bg-offWhite py-16 md:py-32 px-6 md:px-12" data-id="element-62">
        <div className="max-w-5xl mx-auto" data-id="element-63">
          <div className="flex flex-col md:flex-row items-center gap-12 md:gap-24" data-id="element-64">
            <div className="w-full md:w-1/2 relative" data-id="element-65">
              <div className="aspect-[3/4] w-full max-w-[280px] md:max-w-sm mx-auto bg-gray-light border border-black/5 relative z-10" data-id="element-66">
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-67">
                  <span className="font-body text-[10px] text-gray-muted tracking-widest uppercase" data-id="element-68">
                    Agent Portrait
                  </span>
                </div>
              </div>
              {/* Decorative editorial frame */}
              <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-12 w-full max-w-[280px] md:max-w-sm h-full border border-black/5 z-0 hidden md:block" data-id="element-69"></div>
            </div>

            <div className="w-full md:w-1/2 flex flex-col text-center md:text-left" data-id="element-70">
              <div className="flex items-center justify-center md:justify-start gap-4 mb-4 md:mb-6" data-id="element-71">
                <div className="w-8 h-[1px] bg-black" data-id="element-72"></div>
                <span className="font-body text-[10px] text-black tracking-widest uppercase block" data-id="element-73">
                  Exclusive Representation
                </span>
              </div>
              <h3 className="font-display text-4xl md:text-5xl text-black mb-2 md:mb-4" data-id="element-74">
                Senior Agent
              </h3>
              <p className="font-display italic text-xl md:text-2xl text-gray-muted mb-8 md:mb-10" data-id="element-75">
                Agency Name
              </p>

              <div className="flex flex-col gap-4" data-id="element-76">
                <a href="tel:04XXXXXXX" className="font-body font-light text-sm md:text-base text-black hover:text-gray-muted transition-colors flex items-center justify-center md:justify-start gap-4 md:gap-6 group min-h-[44px]" data-id="element-77">
                  <span className="w-8 h-[1px] bg-black/20 group-hover:w-12 transition-all duration-300 hidden md:block" data-id="element-78"></span>
                  04XX XXX XXX
                </a>
                <a href="mailto:agent@agency.com.au" className="font-body font-light text-sm md:text-base text-black hover:text-gray-muted transition-colors flex items-center justify-center md:justify-start gap-4 md:gap-6 group min-h-[44px]" data-id="element-79">
                  <span className="w-8 h-[1px] bg-black/20 group-hover:w-12 transition-all duration-300 hidden md:block" data-id="element-80"></span>
                  agent@agency.com.au
                </a>
              </div>

              <p className="font-body font-light text-sm text-gray-muted mt-8 md:mt-10 leading-relaxed" data-id="element-81">
                For a private inspection or further information, contact us
                directly.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white pt-12 md:pt-16 pb-8 px-6 md:px-12 border-t border-black/5" data-id="element-82">
        <div className="max-w-7xl mx-auto" data-id="element-83">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 md:gap-4" data-id="element-84">
            <p className="font-body text-[10px] text-gray-muted tracking-widest uppercase text-center md:text-left max-w-xl leading-relaxed" data-id="element-85">
              This property is being offered prior to public listing. All
              enquiries are strictly confidential.
            </p>
            <p className="font-body text-[10px] text-gray-muted/50 tracking-widest uppercase" data-id="element-86">
              © 2026 Exclusive Agency
            </p>
          </div>
          <div className="mt-6 pt-6 border-t border-black/5 text-center" data-id="element-87">
            <p className="font-body text-[10px] text-gray-muted/40 tracking-widest uppercase" data-id="element-88">
              Digitally crafted by{' '}
              <a href="https://vaultlab.agency" target="_blank" rel="noopener noreferrer" className="text-gray-muted/60 hover:text-black transition-colors duration-300" data-id="element-89">
                VAULT[LAB]
              </a>{' '}
              · vaultlab.agency
            </p>
          </div>
        </div>
      </footer>

      {/* VAULT[LAB] CTA Footer */}
      <section className="bg-black text-white py-20 md:py-28 px-6 md:px-12" data-id="element-90">
        <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-91">
          {/* Logo */}
          <img src="https://cdn.magicpatterns.com/uploads/aWu5gR31tYCFJYZoPQxy5u/EMAIL_SIG_LITE.png" alt="VAULT[LAB]" className="w-full max-w-xs md:max-w-sm mb-10 md:mb-12" data-id="element-92" />

          {/* Pitch line */}
          <p className="font-display italic text-lg md:text-2xl text-white/80 max-w-2xl leading-relaxed mb-10 md:mb-14" data-id="element-93">
            If one of your listings came to mind while you were reading this —
            that's the one.
          </p>

          {/* CTA */}
          <a href="mailto:elliott@vaultlab.agency" className="group inline-flex items-center gap-4 bg-[#C8FF00] text-black px-8 py-5 min-h-[56px] font-body text-xs tracking-[0.25em] uppercase font-semibold hover:bg-white transition-all duration-500" data-id="element-94">
            Get In Touch
            <span className="w-6 h-[1px] bg-black group-hover:w-10 transition-all duration-500" data-id="element-95"></span>
          </a>
        </div>
      </section>

      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes scroll {
            0% { transform: translateY(-100%); }
            50% { transform: translateY(0); }
            100% { transform: translateY(100%); }
          }
        `
    }} data-id="element-96" />
    </div>;
}